<template>
  <ul class="social">
    <li v-if="facebook !== '#'">
      <a
        :href="facebook"
        target="_blank"
        rel="noopener"
      >
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 26.84"
          role="image"
          aria-label="YOLO Facebookページ"
        >
          <use xlink:href="#icon-facebook" />
        </svg>
      </a>
    </li>
    <li v-if="twitter !== '#'">
      <a
        :href="twitter"
        target="_blank"
        rel="noopener"
      >
        <svg
          width="27"
          height="27"
          viewBox="0 0 28.5 28.5"
          role="image"
          aria-label="YOLO Twitterアカウント"
        >
          <use xlink:href="#icon-twitter" />
        </svg>
      </a>
    </li>
    <li v-if="line !== '#'">
      <a
        :href="line"
        target="_blank"
        rel="noopener"
      >
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          role="image"
          aria-label="YOLO 公式LINEアカウント"
        >
          <use xlink:href="#icon-line" />
        </svg>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'SocialLink',
  props: {
    facebook: {
      type: String,
      default: '#'
    },
    twitter: {
      type: String,
      default: '#'
    },
    line: {
      type: String,
      default: '#'
    }
  }
}
</script>

<style scoped lang="scss">
@use "@/assets/scss/foundation/config/mediaquery";

.social {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  li + li {
    margin-left: 32px;
    @include mediaquery.minMediaMajor {
      margin-left: 50px;
    }
  }

  a {
    color: currentColor;
    text-decoration: none;
  }
  svg {
    fill: currentColor;
    @include mediaquery.minMediaMajor {
      width: 36px;
      height: 36px;
    }
  }
}

.social--large svg {
  @include mediaquery.minMediaMajor {
    width: 40px;
    height: 40px;
  }
}
</style>